"use strict";
exports.__esModule = true;
exports.shoudShowReminderLink = exports.getIcalEventUrl = exports.getCompetitions = exports.getSports = exports.getProviders = exports.getEvents = void 0;
var tslib_1 = require("tslib");
var date_fns_1 = require("date-fns");
var TvProgramApi_1 = tslib_1.__importDefault(require("../../../api/TvProgramApi"));
exports.getEvents = function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var res;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, TvProgramApi_1["default"].publicGetEvents({
                    offset: (_a = params.offset) !== null && _a !== void 0 ? _a : 0,
                    dateFrom: params.dateFrom,
                    dateTo: params.dateTo,
                    limit: params.limit,
                    sport: params.sportId ? [params.sportId] : undefined,
                    provider: params.providerId ? [params.providerId] : undefined,
                    competition: params.competitionId ? [params.competitionId] : undefined,
                    priority: params.priority
                })];
            case 1:
                res = _b.sent();
                return [2 /*return*/, {
                        events: (res.events || []).map(function (event) { return (tslib_1.__assign(tslib_1.__assign({}, event), { dateFrom: new Date(event.dateFrom), dateTo: new Date(event.dateTo) })); }),
                        nextOffset: res.nextOffset
                    }];
        }
    });
}); };
exports.getProviders = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var res;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, TvProgramApi_1["default"].adminGetProviders()];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.providers];
        }
    });
}); };
exports.getSports = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var res;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, TvProgramApi_1["default"].adminGetSports()];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.sports];
        }
    });
}); };
exports.getCompetitions = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var res;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, TvProgramApi_1["default"].adminGetCompetitions()];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.competitions];
        }
    });
}); };
exports.getIcalEventUrl = function (eventId) {
    return process.env.REACT_APP_TVPROGRAM_API_BASE_URL + "/public/events/" + eventId + "/ical";
};
exports.shoudShowReminderLink = function (dateFrom) {
    var now = new Date();
    return now < dateFrom && date_fns_1.differenceInMinutes(dateFrom, now) > 5;
};
